// Firebase configuration
import { initializeApp, getApps, FirebaseApp } from "firebase/app";
import { getAnalytics, Analytics } from "firebase/analytics";
import { getFirestore, Firestore } from "firebase/firestore";
import { getAuth, Auth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyB8nfCHmO_sBrsrgfh4wwQlZZ8sD3cWRDk",
  authDomain: "luxelo.firebaseapp.com",
  projectId: "luxelo",
  storageBucket: "luxelo.firebasestorage.app",
  messagingSenderId: "564615629065",
  appId: "1:564615629065:web:344f639b7ec7c5c7cb6bd8",
  measurementId: "G-EHG6YJPT7S",
};

// Initialize Firebase
const app: FirebaseApp = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

// Initialize Analytics (only in browser)
let analytics: Analytics | undefined;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

// Initialize Firestore
export const db: Firestore = getFirestore(app);

// Initialize Auth (only in browser)
let auth: Auth | undefined;
if (typeof window !== 'undefined') {
  auth = getAuth(app);
}

export { analytics, auth };
export default app;

